import React from 'react';
import { Box } from '@mui/material';
import { color } from 'constants/theme.constant';
import PropTypes from 'prop-types';

const styles = {
  container: {
    backgroundColor: color.background.secondary,
    width: '100%',
    position: 'relative',
  },
};

export default function GreyContainer({ children }) {
  return (
    <React.Fragment>
      <Box sx={styles.container}>{children}</Box>
    </React.Fragment>
  );
}

GreyContainer.propTypes = {
  children: PropTypes.node.isRequired,
}